// Roles that can create / edit / delete content (editor-level access).
export const EDITOR_ROLES = ["admin", "manager", "attorney"];
export const isEditor = (role) => EDITOR_ROLES.includes(role);

// Roles that can view team time-tracking reports.
export const MANAGER_ROLES = ["admin", "manager"];
export const isManager = (role) => MANAGER_ROLES.includes(role);
